import React from 'react';
import {
  ScratchFreeData,
  ScratchListItem,
  getScratchFree,
  getScratchList,
} from '../service';
import ScratdhCard from './home-scratch-card';
import globalStore from '@/services/global.state';

const HomeScratch = () => {
  const [list, setList] = React.useState<(ScratchListItem | null)[]>(
    Array(9).fill(null),
  );
  const [freeList, setFreeList] = React.useState<ScratchFreeData[]>([]);
  const [loginState, setLoginState] = React.useState(!!globalStore.token);

  const getList = () => {
    getScratchList()
      .then(scratchList => {
        setList(scratchList);
      })
      .catch(() => {
        setList([]);
      });

    getScratchFree().then(res => {
      setFreeList(res);
    });
  };

  const resultList = React.useMemo(() => {
    return list.map(item => {
      const freeItem = freeList.find(free => free.scratchName === item?.name);
      return item ? {...item, freeTicketNum: freeItem?.freeTicketNum} : null;
    });
  }, [list, freeList]);

  React.useEffect(() => {
    getList();
  }, [loginState]);

  React.useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(() => {
      setLoginState(!!globalStore.token);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  return (
    <div className="flex flex-row flex-wrap px-3 gap-2">
      {resultList?.map((item, _i) => (
        <ScratdhCard key={_i} v={item} i={_i} />
      ))}
    </div>
  );
};

export default HomeScratch;
